export const getBoundingClientRect = (element) => {
  const { top, right, bottom, left, width, height, x, y } = element.getBoundingClientRect();
  return { top, right, bottom, left, width, height, x, y };
};

//function to find country from url
export const getCountryFromUrl = (forceCountry) => {
  if (forceCountry) return forceCountry;

  const href = window.location.href;

  if (href.includes(".us.")) return "us";
  if (href.includes(".au")) return "aus";
  if (href.includes(".ie")) return "ie";
  return "uk";
};

//capatlise uppercase txt 
export const capitalize = (str) => str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
